const initialState = {
  leagueId: null,
};

// Action creators
export const setLeagueId = (leagueId) => ({
  type: "SET_LEAGUE_ID",
  payload: leagueId,
});

function leagueReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_LEAGUE_ID":
      return {
        ...state,
        leagueId: action.payload,
      };
    default:
      return state;
  }
}

export default leagueReducer;
